import type { PixelSettings } from '../../config/types/pixel-settings';

/**
 * Identidade embutida nos presets BuyGoods.
 * O script tag não aceita pixelId nem settings do integrador.
 */
export const BUYGOODS_PIXEL_ID = 'pix_7704308';

const BUYGOODS_APP = {
  source: 'hwaffiliate',
  platform: 'buygoods',
} as const;

/**
 * Landing: gera `subid4`, escreve na URL e decora todos os links com
 * `subid4` + UTMs / params da query de entrada.
 */
export const BUYGOODS_LANDING_SETTINGS: PixelSettings = {
  identity: {
    pixelId: BUYGOODS_PIXEL_ID,
  },
  app: {
    ...BUYGOODS_APP,
    target: 'landing',
  },
  modules: {
    core: {
      pageView: { enabled: false },
      urlContext: {
        enabled: true,
        queryParams: {
          enabled: true,
          mode: 'all_except',
        },
        forwardParams: {
          enabled: true,
          mode: 'all_except',
        },
        managedParams: [
          {
            key: 'public_session',
            param: 'subid4',
            mode: 'read_write',
            writeStrategy: 'replaceState',
            generator: { type: 'public_id', prefix: 'sid' },
            persistence: { enabled: true },
            decorateLinks: true,
          },
        ],
        linkDecoration: {
          enabled: true,
          strategy: 'both',
          allowedDomains: '*',
        },
      },
    },
    conversion: { enabled: false },
    behavior: { enabled: false },
  },
};

/**
 * Checkout: lê `subid4` da URL (sem escrever). PAGE_VIEW, ATC em
 * email+phone, ADD_PAYMENT_INFO em `#submit`, HEARTBEAT.
 */
export const BUYGOODS_CHECKOUT_SETTINGS: PixelSettings = {
  identity: {
    pixelId: BUYGOODS_PIXEL_ID,
  },
  app: {
    ...BUYGOODS_APP,
    target: 'checkout',
  },
  modules: {
    core: {
      pageView: { enabled: true },
      urlContext: {
        enabled: true,
        managedParams: [
          {
            key: 'public_session',
            param: 'subid4',
            mode: 'read_only',
            writeStrategy: 'none',
            persistence: { enabled: false },
          },
        ],
        linkDecoration: { enabled: false },
      },
    },
    conversion: {
      auto: {
        detectors: {
          lead: { enabled: false },
          removeFromCart: { enabled: false },
          purchase: { enabled: false },
          search: { enabled: false },
          viewContent: { enabled: false },
          initiateCheckout: { enabled: false },
          addToCart: {
            enabled: true,
            sources: [
              {
                name: 'buygoods-email-phone',
                type: 'form',
                fireOnce: true,
                selectorForm: {
                  fields: ['email', 'phone'],
                  mode: 'all',
                  trigger: 'auto',
                  debounceMs: 300,
                  fireOnce: true,
                },
              },
            ],
          },
          addPaymentInfo: {
            enabled: true,
            sources: [
              {
                name: 'buygoods-pay-button',
                type: 'selector',
                selector: '#submit',
                selectorType: 'css',
                trigger: 'click',
                fireOnce: true,
              },
            ],
          },
        },
      },
    },
    behavior: {
      enabled: true,
      heartbeat: { enabled: true },
    },
  },
};
